/* eslint-disable @typescript-eslint/default-param-last */
import initialState from '../../store/initialState';
import { GET_TECHNOLOGIES } from '../../constants/ActionTypes';
import { ITechnologyAction } from '../../types/Interviews/technologies.type';

const technologiesReducer = (
  state = initialState.technologies,
  action: ITechnologyAction
) => {
  switch (action.type) {
    case `${GET_TECHNOLOGIES}_SUCCESS`:
      return {
        ...state,
        ...action.payload.technologies,
      };
    default:
      return state;
  }
};

export default technologiesReducer;
